import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { deleteNotificationDestination } from 'services/WebHooksService'

export const useDeleteNotificationDestinationMutation = () => {
  return useMutation({
    mutationFn: deleteNotificationDestination,
    onError(error: { status: number; message?: string; errorList?: unknown }, data) {
      logSentryError('Error from useDeleteWebhookDestinationMutation', error, data)
    },
  })
}
